import React, { useState } from 'react';
import axios from '../utils/axios';
import './CreateCustomer.css';

function CreateCustomer({ onCustomerCreated }) {
  const [formData, setFormData] = useState({
    givenName: '',
    middleName: '',
    familyName: '',
    suffix: '',
    title: '',
    displayName: '',
    companyName: '',
    primaryEmail: '',
    primaryPhone: '',
    notes: '',
    billAddrLine1: '',
    billAddrCity: '',
    billAddrPostalCode: '',
    billAddrCountrySubDivisionCode: '',
    billAddrCountry: 'USA'
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (!formData.displayName) {
      setError('Display Name is required');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post('/api/quickbooks/create-customer', formData);
      
      setSuccess(`Customer "${response.data.Customer.DisplayName}" created successfully!`);
      
      setFormData({
        givenName: '',
        middleName: '',
        familyName: '',
        suffix: '',
        title: '',
        displayName: '',
        companyName: '',
        primaryEmail: '',
        primaryPhone: '',
        notes: '',
        billAddrLine1: '',
        billAddrCity: '',
        billAddrPostalCode: '',
        billAddrCountrySubDivisionCode: '',
        billAddrCountry: 'USA'
      });

      if (onCustomerCreated) {
        onCustomerCreated(response.data.Customer);
      }
    } catch (err) {
      console.error('Error creating customer:', err);
      setError(err.response?.data?.error || 'Failed to create customer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-customer-container">
      <h2>Create New Customer</h2>
      
      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleSubmit} className="customer-form">
        <div className="form-section">
          <h3>Personal Information</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Mr, Mrs, Dr, etc."
              />
            </div>
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                name="givenName"
                value={formData.givenName}
                onChange={handleChange}
                placeholder="James"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Middle Name</label>
              <input
                type="text"
                name="middleName"
                value={formData.middleName}
                onChange={handleChange}
                placeholder="B"
              />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                name="familyName"
                value={formData.familyName}
                onChange={handleChange}
                placeholder="King"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Suffix</label>
              <input
                type="text"
                name="suffix"
                value={formData.suffix}
                onChange={handleChange}
                placeholder="Jr, Sr, III, etc."
              />
            </div>
            <div className="form-group">
              <label>Display Name *</label>
              <input
                type="text"
                name="displayName"
                value={formData.displayName}
                onChange={handleChange}
                placeholder="King's Groceries"
                required
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Company Information</h3>
          <div className="form-group full-width">
            <label>Company Name</label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              placeholder="King Groceries"
            />
          </div>
        </div>

        <div className="form-section">
          <h3>Contact Information</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="primaryEmail"
                value={formData.primaryEmail}
                onChange={handleChange}
                placeholder="jdrew@myemail.com"
              />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input
                type="tel"
                name="primaryPhone"
                value={formData.primaryPhone}
                onChange={handleChange}
                placeholder="(555) 555-5555"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Billing Address</h3>
          <div className="form-group full-width">
            <label>Street Address</label>
            <input
              type="text"
              name="billAddrLine1"
              value={formData.billAddrLine1}
              onChange={handleChange}
              placeholder="123 Main Street"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>City</label>
              <input
                type="text"
                name="billAddrCity"
                value={formData.billAddrCity}
                onChange={handleChange}
                placeholder="Mountain View"
              />
            </div>
            <div className="form-group">
              <label>State/Province</label>
              <input
                type="text"
                name="billAddrCountrySubDivisionCode"
                value={formData.billAddrCountrySubDivisionCode}
                onChange={handleChange}
                placeholder="CA"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Postal Code</label>
              <input
                type="text"
                name="billAddrPostalCode"
                value={formData.billAddrPostalCode}
                onChange={handleChange}
                placeholder="94042"
              />
            </div>
            <div className="form-group">
              <label>Country</label>
              <input
                type="text"
                name="billAddrCountry"
                value={formData.billAddrCountry}
                onChange={handleChange}
                placeholder="USA"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Additional Notes</h3>
          <div className="form-group full-width">
            <label>Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Here are other details."
              rows="4"
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Creating...' : 'Create Customer'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateCustomer;
